import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'
import classnames from 'classnames'

import FieldLabelWrapperComponent from '../../../../../../features/components/Form/FieldLabelWrapper'
import Toggle from '../../../../../../components/Toggle'

import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../../reusableFields'
import { PLATFORMS } from '../fields'
import { FACEBOOK_AND_TIKTOK } from '../PlatformsFieldWrapper/fields'
import { FACEBOOK_PLATFORM, TIKTOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { toggleWrapperContent } from './styles.css'
import { fieldContent } from '../styles.css'

const FieldLabelWrapper = FieldLabelWrapperComponent as any

interface CampaignLevelBudgetToggleProps {
  formik: FormikProps<any>
}

const CampaignLevelBudgetToggle: React.FC<CampaignLevelBudgetToggleProps> = ({ formik }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const isEnabled = values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]
  const selectedPlatform = values[PLATFORMS]

  const toggleHandler = useCallback(() => {
    setFieldValue(AUTO_OPTIMIZED_CAMPAIGN_BUDGET, !isEnabled)
  }, [isEnabled, setFieldValue])

  const helpText = useMemo(() => {
    // Return generic help text if no platform is selected
    if (!selectedPlatform) {
      return 'Set a single budget for the entire campaign. The platform will allocate spend for best performance.'
    }

    const isMeta = selectedPlatform === FACEBOOK_PLATFORM
    const isTikTok = selectedPlatform === TIKTOK_PLATFORM
    const isBoth = selectedPlatform === FACEBOOK_AND_TIKTOK

    const platformPhrase = isBoth ? 'per platform ' : ''

    let adStructurePhrase = ''
    if (isBoth) {
      adStructurePhrase = 'ad sets / ad groups'
    } else if (isMeta) {
      adStructurePhrase = 'ad sets'
    } else if (isTikTok) {
      adStructurePhrase = 'ad groups'
    }

    return `Set a single budget ${platformPhrase}for the entire campaign. The platform will allocate spend across ${adStructurePhrase} for best performance.`
  }, [selectedPlatform])

  return (
    <FieldLabelWrapper
      contentClassName={classnames(fieldContent, toggleWrapperContent)}
      label={t('Campaign level budget')}
      horizontalView={true}
      helpText={t(helpText)}
    >
      <Toggle isEnabled={isEnabled} onToggle={toggleHandler} />
    </FieldLabelWrapper>
  )
}

export default CampaignLevelBudgetToggle
